var map = {
	"./CARRINHO.svg": "0a02",
	"./E-MAIL.svg": "7f88",
	"./INSUFLÁVEIS - AZUL.svg": "ff42",
	"./INSUFLÁVEIS - ROSA.svg": "c139",
	"./PESQUISAR.svg": "5333",
	"./SHAPE.svg": "4fa7",
	"./USER.svg": "d294b",
	"./arrowProductDetail.svg": "b742",
	"./arrowsContact.svg": "dc8d",
	"./heroFormActive.svg": "3b3f",
	"./heroFormActive1.svg": "74c3",
	"./heroFormInflate.svg": "5447",
	"./heroFormInflate1.svg": "0d76",
	"./homeArrowActive.svg": "f11f",
	"./homeArrowInflate.svg": "d7ef",
	"./icon-play.svg": "1f8f",
	"./icon-youtube.svg": "55ef",
	"./inflatableBlue.svg": "4914",
	"./inflatableBlueContact.svg": "b0e6",
	"./inflatablePink.svg": "1143",
	"./inflatablePinkContact.svg": "d264",
	"./insuflavelGrandeAzul.svg": "aec0",
	"./insuflavelGrandeRosa.svg": "958b1",
	"./setaShop.svg": "1afd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46f5";